import type { EditorActions } from '@atlaskit/editor-core';

import type {
	UpdateMainFormFieldType as UpdateCardsMainFormFieldType,
	UpdateCardFormFieldForAllCardsType,
} from '../../link-cards/LinkCardsConfigPanel/configPanelTypes';
import type { UpdateMainFormFieldType as UpdateCarouselMainFormFieldType } from '../../carousel/CarouselConfigPanel/configPanelTypes';
import type { ButtonStyle, Layout, Height } from '../styleTypes';

export type UpdateField<T> = Partial<T>;

export type UseExtensionParametersAndActionsProps = {
	localId: string;
	editorActions: EditorActions;
};

export type AddItemType = () => void;
export type RemoveItemType = (cardId: string) => void;
export type UpdateMainFormFieldType =
	| UpdateCardsMainFormFieldType
	| UpdateCarouselMainFormFieldType;
export type UpdateItemFormFieldType = (cardId: string, updatedField: UpdateField<Item>) => void;
/** @todo create UpdateItemFormFieldForAllItemsType if segmentation for all frames or cards implemented for carousel and cards extension */
export type { UpdateCardFormFieldForAllCardsType };

export enum ITEM_FIELDS {
	CARD_ID = 'cardId',
	TITLE = 'title',
	IS_TITLE_USER_EDITED = 'isTitleUserEdited',
	DESCRIPTION = 'description',
	IS_DESCRIPTION_USER_EDITED = 'isDescriptionUserEdited',
	LINK = 'link',
	IS_LINK_USER_EDITED = 'isLinkUserEdited',
	IMAGE_SRC = 'imageSrc',
	CONFLUENCE_PAGE_ID = 'confluencePageId',
	IMAGE_ALT_TEXT = 'imageAltText',
	AUDIENCE_SEGMENTATION_GROUP_IDS = 'audienceSegmentationGroupIds', // group preferences stored via this field when segmentationTarget is EACH
	LINK_RESOURCE_TYPE = 'linkResourceType',
	BACKGROUND_COLOR = 'backgroundColor',
	TEXT_COLOR = 'textColor',
	LAYOUT = 'layout',
	IS_BUTTON_SHOWN = 'isButtonShown',
	BUTTON_TEXT = 'buttonText',
	BUTTON_STYLE = 'buttonStyle',
	HEIGHT = 'height',
}

export type Item = {
	[ITEM_FIELDS.CARD_ID]: string;
	[ITEM_FIELDS.LINK]: string;
	[ITEM_FIELDS.IS_LINK_USER_EDITED]?: boolean;
	[ITEM_FIELDS.TITLE]?: string;
	[ITEM_FIELDS.IS_TITLE_USER_EDITED]?: boolean;
	[ITEM_FIELDS.DESCRIPTION]?: string;
	[ITEM_FIELDS.IS_DESCRIPTION_USER_EDITED]?: boolean;
	[ITEM_FIELDS.IMAGE_SRC]?: string;
	[ITEM_FIELDS.IMAGE_ALT_TEXT]?: string;
	[ITEM_FIELDS.AUDIENCE_SEGMENTATION_GROUP_IDS]?: string[];
	[ITEM_FIELDS.LINK_RESOURCE_TYPE]?: string;
	[ITEM_FIELDS.CONFLUENCE_PAGE_ID]?: string;
	[ITEM_FIELDS.BACKGROUND_COLOR]?: string;
	[ITEM_FIELDS.TEXT_COLOR]?: string;
	[ITEM_FIELDS.LAYOUT]?: Layout;
	[ITEM_FIELDS.IS_BUTTON_SHOWN]?: boolean;
	[ITEM_FIELDS.BUTTON_TEXT]?: string;
	[ITEM_FIELDS.BUTTON_STYLE]?: ButtonStyle;
	[ITEM_FIELDS.HEIGHT]?: Height;
};

export enum CONDITIONAL_FIELDS {
	IS_AVATAR_SHOWN = 'isAvatarShown',
	IS_PUBLISH_DATE_SHOWN = 'isPublishDateShown',
	IS_SEGMENTATION_SHOWN = 'isSegmentationShown',
}
